import {
  ArrowRight,
  ArrowUpRight,
  Clock3,
  Facebook,
  Instagram,
  MapPin,
  MessagesSquare,
} from 'lucide-react';
import { imgAlcanceCartel } from '../assets';
import { Layout } from '../components/Layout';
import { PageHero } from '../components/PageHero';
import { useReveal } from '../hooks';
import { churchAddress, facebookUrl, instagramUrl, mapEmbedUrl, mapUrl, services } from '../site';

const contactCards = [
  {
    icon: Facebook,
    title: 'Facebook',
    text: 'Nuestro canal principal: transmisiones, anuncios y mensajes. Escríbenos por Messenger.',
    action: 'Enviar mensaje',
    href: facebookUrl,
    featured: true,
  },
  {
    icon: Instagram,
    title: 'Instagram',
    text: 'El día a día de la comunidad: fotos, fragmentos y próximos eventos.',
    action: 'Seguir y escribir',
    href: instagramUrl,
    featured: false,
  },
  {
    icon: MapPin,
    title: 'Ubicación',
    text: `${churchAddress.street}, ${churchAddress.locality}. Abre la ruta en Google Maps.`,
    action: 'Cómo llegar',
    href: mapUrl,
    featured: false,
  },
];

export function ContactoPage() {
  useReveal();

  return (
    <Layout>
      <PageHero
        kicker="Contacto"
        title={<>Hablemos, <em>estamos cerca</em>.</>}
        lead="¿Tienes una pregunta, una petición de oración o quieres visitarnos? Escríbenos por nuestras redes; respondemos con gusto."
        image={imgAlcanceCartel}
      >
        <a className="button button-gold" href={facebookUrl} target="_blank" rel="noopener noreferrer">
          <MessagesSquare size={18} aria-hidden="true" /> Escríbenos por Facebook
        </a>
      </PageHero>

      <section className="section-space" aria-labelledby="channels-title">
        <div className="page-shell">
          <div className="section-heading reveal">
            <div>
              <p className="section-kicker">
                <span /> Canales directos
              </p>
              <h2 id="channels-title">Elige cómo contactarnos.</h2>
            </div>
            <p>
              Facebook es nuestro canal principal: ahí estamos atentos durante
              toda la semana.
            </p>
          </div>
          <div className="contact-grid">
            {contactCards.map(({ icon: Icon, title, text, action, href, featured }) => (
              <a
                className={`contact-card reveal ${featured ? 'is-featured' : ''}`}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                key={title}
              >
                <span className="contact-card-icon">
                  <Icon size={26} aria-hidden="true" />
                </span>
                <h3>{title}</h3>
                <p>{text}</p>
                <span className="contact-card-action">
                  {action} <ArrowUpRight size={18} aria-hidden="true" />
                </span>
              </a>
            ))}
          </div>
        </div>
      </section>

      <section className="section-space contact-info-section" aria-labelledby="info-title">
        <div className="page-shell contact-info-layout">
          <div className="contact-info reveal">
            <p className="section-kicker">
              <span /> Antes de escribir
            </p>
            <h2 id="info-title">Quizás esto te ayude.</h2>
            <ul className="contact-facts">
              <li>
                <Clock3 size={20} aria-hidden="true" />
                <div>
                  <strong>Servicios</strong>
                  <p>
                    {services.map((service) => `${service.day} ${service.time}`).join(' · ')}
                  </p>
                </div>
              </li>
              <li>
                <MapPin size={20} aria-hidden="true" />
                <div>
                  <strong>Dirección</strong>
                  <p>{churchAddress.street}, {churchAddress.locality}</p>
                </div>
              </li>
              <li>
                <MessagesSquare size={20} aria-hidden="true" />
                <div>
                  <strong>¿Primera vez?</strong>
                  <p>
                    Revisa la <a className="text-link" href="/visita/">guía de tu visita</a>:
                    qué esperar, horarios y preguntas frecuentes.
                  </p>
                </div>
              </li>
            </ul>
            <a className="button button-primary" href="/visita/">
              Planifica tu visita <ArrowRight size={18} aria-hidden="true" />
            </a>
          </div>
          <div className="location-map reveal">
            <iframe
              title="Mapa de Iglesia Cristiana Tercer Cielo"
              src={mapEmbedUrl}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </section>
    </Layout>
  );
}
